export class SortCompanyModel {
    sortCol: string = "";
    sortType: number = 0;

    // hidecompany
    hidecompany: number = 5;
    companyhideSurrKey: number = 0;

    // badgecompany
    badgecompany: number = 5;
    companybadgeSurrKey: number = 0;

    gradecompany: string = "";
}

export class FilterCompanyModel {
    isbadge: string = "";
    country: string = "";
}
